module.exports = __webpack_public_path__ + "img/sad.114469b6.svg";